module.exports = __webpack_public_path__ + "static/office_by_entrance-a79d1881488381b7a7845bec6e54ca8f.jpg";